






















































































import { Component, Vue } from 'vue-property-decorator';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';
import TransactionsList from '@/componentsV2/organisms/TransactionList/TransactionsList.vue';
import PerformanceCustomerCenterService from '@/api/PerformanceCustomerCenterService';
import {
  EPaymentStatusTransaction,
  EREturnPolicy,
  IPerformanceTransactionData,
  LoyaltyStatus
} from '@/models/performance';
import PaginationUtils, {
  EPaginationSortDir,
  IPagination,
  IPaginationTableHeader
} from '@/utils/PaginationUtils';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import { Pagination } from '@/models/general';
import { IPerformanceTransaction } from '@/models/performance';
import { IPeriod } from '@/models/period';
import PerformanceUtils from '@/utils/PerformanceUtils';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import { Business } from '@/store/modules/businessTypes';
import { sleep } from '@/utils';

@Component({
  components: {
    SectionData,
    TransactionsList,
    TableFilters,
    CustomSelect,
    Typography,
    Trigger,
    SectionWrapper
  }
})
export default class PerformanceTransactionList extends Vue {
  performanceCustomerCenterService: PerformanceCustomerCenterService = new PerformanceCustomerCenterService();

  pagination: IPagination = PaginationUtils.defaultPagination();
  filters: Record<string, any> = this.defaultFilters;

  headers: Record<string, IPaginationTableHeader> = this.mountHeaderTable();
  transactions: IPerformanceTransaction[] = [];

  period: IPeriod = PerformanceUtils.defaultPeriod();

  search = {
    placeholder: 'Search by customer',
    term: ''
  };

  firstRequestWasMade = false;
  filterPaymentStatus = this.createPaymentStatusFilter();
  filterReturnPolicy = this.createReturnPolicyFilter();
  filterLoyaltyStatus = this.createLoyaltyStatusFilter();

  loading = false;

  get tPrefix() {
    return 'performance.transactionsCenter';
  }

  get gaTracking() {
    return {
      search: {
        eventCategory: 'List transactions - Search',
        eventAction: 'change'
      },
      select: {
        eventCategory: 'List transactions - Select',
        eventAction: 'change'
      }
    };
  }

  get defaultFilters() {
    const { search, additionalFilters, ...rest } = this.cachedFilters;

    if (!Object.keys(rest).length) {
      return {
        sort: 'connectTransaction.createdAt:DESC',
        searchableFields: 'customer.name'
      };
    }
    return rest;
  }

  get cachedTransactions() {
    return this.$store.getters['performance/getListTransactionsCenterState']
      .list;
  }

  get cachedPagination() {
    return this.$store.getters['performance/getListTransactionsCenterState']
      .config.pagination;
  }

  get cachedFilters() {
    return this.$store.getters['performance/getListTransactionsCenterState']
      .config.filters;
  }

  get cachedConfig() {
    return this.$store.getters['performance/getListTransactionsCenterState']
      .config;
  }

  get cachedAdditionalFilters() {
    return this.$store.getters['performance/getListTransactionsCenterState']
      .config.filters.additionalFilters as {
      filterPaymentStatus: CustomSelectModel;
      filterReturnPolicy: CustomSelectModel;
      filterLoyaltyStatus: CustomSelectModel;
    };
  }

  get business() {
    return this.$store.getters['business/getBusinessState'] as Business;
  }

  get hasEnabledRefundPolicy() {
    return !!this.business.hadRefund;
  }

  mounted() {
    this.loadCacheAdditionalFilters();
    this.loadPositionScroll();
  }

  loadPositionScroll() {
    const containerScrollElement = document.querySelector(
      '.container-scrollable'
    );

    if (containerScrollElement) {
      containerScrollElement.scrollTo(0, this.cachedConfig.scrollYPos);
    }

    this.clearPositionScroll();
  }

  clearPositionScroll() {
    this.$store.dispatch('performance/SET_CONFIG', {
      context: 'transactionsCenter',
      config: {
        ...this.cachedConfig,
        ...{
          scrollYPos: 0
        }
      }
    });
  }

  handleItemClick() {
    this.saveCache({ saveScrollPosition: true });
  }

  loadCacheAdditionalFilters() {
    if (this.cachedAdditionalFilters) {
      this.filterPaymentStatus = this.cachedAdditionalFilters.filterPaymentStatus;
      this.filterReturnPolicy = this.cachedAdditionalFilters.filterReturnPolicy;
      this.filterLoyaltyStatus = this.cachedAdditionalFilters.filterLoyaltyStatus;
    }
  }

  updateTransactionList(transactionUpdated: IPerformanceTransaction) {
    this.transactions = this.transactions.map(transaction => {
      if (transaction.id === transactionUpdated.id) {
        transaction = transactionUpdated;
      }

      return transaction;
    });
  }

  mountHeaderTable() {
    const business = this.$store.getters[
      'business/getBusinessState'
    ] as Business;
    return {
      createdAt: {
        label: 'Date',
        sortable: true,
        nameColumnOrderBy: 'connectTransaction.createdAt'
      },
      customerName: {
        label: 'Customer',
        sortable: true,
        nameColumnOrderBy: 'customer.name'
      },
      moneyAmount: {
        label: 'Amount',
        sortable: true,
        nameColumnOrderBy: 'connectTransaction.moneyAmount'
      },
      coinsAmount: {
        label: 'Coins minted',
        sortable: true
      },
      cardLast4: {
        label: 'Last 4 digits',
        sortable: true,
        sortDir: EPaginationSortDir.DESC
      },
      paymentStatus: {
        label: 'Payment status',
        sortable: true
      },
      ...(business.hadRefund && {
        returnPolicy: {
          label: 'Return policy',
          sortable: true
        }
      }),
      loyaltyStatus: {
        label: 'Reward',
        sortable: true
      }
    };
  }

  createPaymentStatusFilter() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption(
        EPaymentStatusTransaction.PROCESSING,
        `Processing`
      ),
      new CustomSelectOption(EPaymentStatusTransaction.OVERDUE, `Overdue`),
      new CustomSelectOption(EPaymentStatusTransaction.CONFIRMED, `Confirmed`),
      new CustomSelectOption(
        EPaymentStatusTransaction.REFUNDED_PARTIALLY,
        `Refund partially`
      ),
      new CustomSelectOption(EPaymentStatusTransaction.REFUNDED, `Refunded`)
    ]);

    return new CustomSelectModel(
      [actionGroup],
      `Payment status`,
      false,
      true,
      true,
      false
    );
  }

  createReturnPolicyFilter() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption(EREturnPolicy.PENDING, `Pending`),
      new CustomSelectOption(EREturnPolicy.COMPLETED, `Completed`)
    ]);

    return new CustomSelectModel(
      [actionGroup],
      `Return policy`,
      false,
      true,
      true,
      false
    );
  }

  createLoyaltyStatusFilter() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption(LoyaltyStatus.PENDING, `Pending`),
      new CustomSelectOption(LoyaltyStatus.COMPLETED, `Completed`),
      new CustomSelectOption(LoyaltyStatus.CANCELED, `Canceled`)
    ]);

    return new CustomSelectModel(
      [actionGroup],
      `Loyalty status`,
      false,
      true,
      true,
      false
    );
  }

  transactionsMapper(transactions: Pagination<IPerformanceTransactionData>) {
    const { items } = transactions;

    return items.map(transaction => {
      const {
        connectTransaction,
        customer,
        business,
        businessCountry
      } = transaction;

      return {
        id: connectTransaction.id,
        createdAt: new Date(connectTransaction.createdAt),
        clearedAt: connectTransaction.clearedAt
          ? new Date(connectTransaction.clearedAt)
          : null,
        status: connectTransaction.status,
        provider: connectTransaction.provider,
        moneyAmount: connectTransaction.moneyAmount,
        cardLast4: connectTransaction.cardLast4,
        coinsStatus: connectTransaction.coinsStatus,
        coinsAmount: connectTransaction.coinsAmount,
        refundStatus: connectTransaction.refundStatus,
        refundableUntil: new Date(connectTransaction.refundableUntil),
        customerId: customer.id,
        customerName: customer.name,
        businessId: business.id,
        businessName: business.name,
        currency: businessCountry.currency,
        lang: businessCountry.lang,
        currencySymbol: businessCountry.currencySymbol,
        paymentStatus: transaction.paymentStatus,
        returnPolicy: transaction.returnPolicy,
        loyaltyStatus: transaction.loyaltyStatus,
        coinsGiven: connectTransaction.coinsGiven,
        coinsRefundAmount: connectTransaction.coinsRefundAmount
      };
    });
  }

  async loadTransactions({ clearList = false, showLoader = true } = {}) {
    if (clearList) {
      this.pagination = PaginationUtils.defaultPagination();
    }

    if (!this.pagination.mustCallApi) return;

    let endpointPath = '/admin/lambda-webhooks/transactions';

    if (this.pagination.next) {
      endpointPath = this.pagination.next;
    }

    this.loading = true;

    if (showLoader) this.$showLoaderWithLocker(true);

    const additionalFilters = this.prepareAdditionalFilters();

    const response = await this.performanceCustomerCenterService.listTransactions(
      endpointPath,
      !this.pagination.next
        ? {
            ...this.filters,
            ...additionalFilters
          }
        : {}
    );

    if (showLoader) this.$hideLoader();
    this.loading = false;

    if (response.status !== 200) return;

    const { links } = response.data;

    Object.assign(this.pagination, {
      next: links.next,
      mustCallApi: !!links.next
    });

    if (clearList) {
      this.transactions = this.transactionsMapper(response.data);
      this.saveCache();
      return;
    }

    this.transactions = [
      ...this.transactions,
      ...this.transactionsMapper(response.data)
    ];

    this.saveCache();

    this.firstRequestWasMade = true;

    PaginationUtils.makeNewRequest(
      {
        triggerClass: '.infinite-trigger',
        hasPagination: !!this.pagination.next
      },
      () => {
        this.loadTransactions({ showLoader: false });
      }
    );
  }

  saveCache({ saveScrollPosition = false } = {}) {
    const newPeriod = PerformanceUtils.normalizedPeriod(this.period);

    const containerScrollElement =
      saveScrollPosition && document.querySelector('.container-scrollable');

    this.$store.dispatch('performance/SET_CONFIG', {
      context: 'transactionsCenter',
      config: {
        pagination: this.pagination,
        filters: {
          ...this.filters,
          ...{
            from: newPeriod.start,
            to: newPeriod.end
          },
          ...{
            additionalFilters: {
              filterPaymentStatus: this.filterPaymentStatus,
              filterReturnPolicy: this.filterReturnPolicy,
              filterLoyaltyStatus: this.filterLoyaltyStatus
            }
          }
        },
        ...(containerScrollElement && {
          scrollYPos: containerScrollElement.scrollTop
        })
      }
    });
    this.$store.dispatch('performance/SET_LIST_DATA', {
      context: 'transactionsCenter',
      list: this.transactions
    });
  }
  prepareAdditionalFilters() {
    const getValuesSelected = (filter: CustomSelectModel): string[] => {
      return (
        filter.filteredGroups[0].options
          .filter(option => option.isSelected)
          .map(el => el.uuid) || []
      );
    };

    return {
      paymentStatus: getValuesSelected(this.filterPaymentStatus),
      returnPolicy: getValuesSelected(this.filterReturnPolicy),
      loyaltyStatus: getValuesSelected(this.filterLoyaltyStatus)
    };
  }

  handleSort(field: string) {
    this.headers = PaginationUtils.getUpdatedHeaders(field, this.headers);

    const { sortDir, nameColumnOrderBy } = this.headers[field];

    this.$analytics({
      eventCategory: 'Transaction Center - Sort',
      eventAction: 'click',
      eventLabel: `[${sortDir}] ${this.headers[field].label} column`
    });

    const column = nameColumnOrderBy || `${field}`;

    this.filters = {
      ...this.filters,
      sort: `${column}:${sortDir}`
    };
    this.loadTransactions({ clearList: true });
  }

  handleSearchFilterChange() {
    delete this.filters.search;

    if (this.search.term) {
      this.filters = {
        ...this.filters,
        search: this.search.term
      };
    }

    this.loadTransactions({ clearList: true });
  }

  handlePeriodChange(period: IPeriod) {
    this.period = PerformanceUtils.normalizedPeriod(period);

    this.filters = {
      ...this.filters,
      from: this.period.start,
      to: this.period.end
    };

    this.loadTransactions({ clearList: true });
  }
}
